import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import PhilosophySection from './components/PhilosophySection';
import TransformationSection from './components/TransformationSection';
import PlatformSection from './components/PlatformSection';
import TestimonialsSection from './components/TestimonialsSection';
import EssaysSection from './components/EssaysSection';
import CommunitySection from './components/CommunitySection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <PhilosophySection />
      <TransformationSection />
      <PlatformSection />
      <TestimonialsSection />
      <EssaysSection />
      <CommunitySection />
      <CTASection />
      <Footer />
    </main>
  );
}